/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_DialogueInputs */



/**
* | output |
* | --- |
* | "DIALOGUE" |
*
* @param {Ccsl_Export_Header_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_dialogue = /** @type {((inputs?: Ccsl_Export_Header_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DIALOGUE")
	if (locale === "de") return /** @type {LocalizedString} */ ("DIALOG")
	if (locale === "it") return /** @type {LocalizedString} */ ("DIALOGO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ДИАЛОГ")
	if (locale === "es") return /** @type {LocalizedString} */ ("DIÁLOGO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対話")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वार्ता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("DIÁLOGO")
	return /** @type {LocalizedString} */ ("DIALOGUE")
});